export const HoriLine = () => (
  <svg width="16" height="1" viewBox="0 0 16 1" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line y1="0.5" x2="16" y2="0.5" stroke="#999999" />
  </svg>
);
